import React from "react";
import { Link } from "react-router-dom";
import BusinessThemes from "../Data/ThemeStoreData/WixThemes/BusinessThemes";

const featuredThemes = BusinessThemes.slice(0, 3);

const ThemeShowcase = () => {
  return (
    <section className="theme-showcase-area section-gap" id="themes">
      <div className="container">
        <div className="row d-flex justify-content-center">
          <div className="menu-content col-lg-8">
            <div className="title text-center">
              <h1 className="mb-10">Ready-Made Themes, Ready to Launch</h1>
              <p>
                Pick a theme you like and get your website live in days, not
                weeks.
              </p>
            </div>
          </div>
        </div>
        <div className="row grid mb-30">
          {featuredThemes.map((item, index) => (
            <Link
              to={`/theme/${item.urlSuffix}`}
              className="single-portfolio col-sm-4 all web mb-3"
              key={index}
            >
              <div className="relative mb-2">
                <div className="thumb">
                  <div className="overlay overlay-bg" />
                  <div className="screen">
                    <img
                      className="image-prop img-fluid"
                      src={item.image}
                      alt={item.caption}
                    />
                  </div>
                </div>
              </div>
              <div className="p-inner">
                <h4>{item.title}</h4>
                <div className="cat">{item.caption}</div>
              </div>
            </Link>
          ))}
        </div>
        <div className="row d-flex justify-content-center">
          <div className="col-auto">
            <Link
              to="/theme-store"
              className="primary-btn text-uppercase px-4"
            >
              Browse All Themes
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThemeShowcase;
